import { defineComponent as _defineComponent } from 'vue'

// el-dropdown is not globally registered (see globalComponents.js); register
// locally like every other consumer. Unaliased imports only.
import { Dropdown, DropdownMenu } from 'element-ui'

const __default__ = {
  name: 'passes-list',
  components: {
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu
  }
}

import { ref, computed, onMounted, getCurrentInstance } from 'vue'
import axios from 'axios'
import swal from 'sweetalert2'
import { Auth } from 'aws-amplify'
import { API_LOCATION } from '@/api-config'
import { formatCurrency, getGroupSettings } from '@/util/currencyFormat'
import PassTypeDrawer from './PassTypeDrawer.vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { proxy } = getCurrentInstance() as any

const companyId = localStorage.getItem('companyId')
const companyGroupId = JSON.parse(localStorage.getItem('group') || '{}').id
const baseUrl = `${API_LOCATION}companies/${companyId}/groups/${companyGroupId}`

const loading = ref(true)
const passTypes = ref<any[]>([])
const view = ref('active')
const j = ref(0)
const categories = ref([
  { name: 'Active', icon: 'tim-icons icon-check-2', active: true },
  { name: 'Archived', icon: 'tim-icons icon-trash-simple', active: false }
])

const drawerOpen = ref(false)
const selectedPassType = ref<any>(null)

const visiblePassTypes = computed(() =>
  passTypes.value.filter((pt) => (view.value === 'archived' ? pt.is_archived === 1 : pt.is_archived === 0)))

function durationText(passType: any) {
  const plural = passType.duration_value === 1 ? '' : 's'
  return `${passType.duration_value} ${passType.duration_unit}${plural}`
}

function allowanceText(passType: any) {
  const tickets = `${passType.ticket_allowance} ticket${passType.ticket_allowance === 1 ? '' : 's'}`
  return passType.allowance_type === 'per_booking' ? `${tickets} per booking` : `${tickets} total`
}

function gamesText(passType: any) {
  if (passType.applies_to_all_games === 1) return 'All events'
  const count = (passType.games || []).length
  return `${count} event${count === 1 ? '' : 's'}`
}

function priceText(passType: any) {
  const group = getGroupSettings()
  return formatCurrency(passType.price, {
    currency: group.currency,
    currencyFormat: group.currency_format,
    numberFormat: group.number_format
  })
}

async function authConfig() {
  const session = await Auth.currentSession()
  return { headers: { Authorization: (session as any).idToken.jwtToken } }
}

async function getPassTypes(showLoader = true) {
  if (showLoader) loading.value = true
  try {
    const config = await authConfig()
    const response = await axios.get(`${baseUrl}/pass-types`, config)
    passTypes.value = response.data.pass_types || []
  } catch (err: any) {
    if (err?.response?.status === 401 || err?.response?.status === 403) {
      proxy.$router.push('/forbidden')
      return
    }
    swal('Error!', 'Failed to load pass types', 'error')
  } finally {
    loading.value = false
  }
}

function switchTab(index: number) {
  categories.value.forEach((option, i) => { option.active = i === index })
  j.value += 1
  view.value = index === 1 ? 'archived' : 'active'
}

function createPassType() {
  selectedPassType.value = null
  drawerOpen.value = true
}

function editPassType(passType: any) {
  selectedPassType.value = passType
  drawerOpen.value = true
}

function archivePrompt(passType: any) {
  swal({
    title: 'Archive this pass type?',
    text: 'Existing customer passes keep working, but no new passes of this type can be granted or sold.',
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Archive',
    cancelButtonText: 'Keep it'
  }).then((result: any) => {
    if (!result.value) return
    setArchived(passType, true)
  })
}

async function setArchived(passType: any, archived: boolean) {
  try {
    const config = await authConfig()
    await axios.put(`${baseUrl}/pass-types/${passType.id}/archive`, { is_archived: archived ? 1 : 0 }, config)
    proxy.$notify({
      type: 'success',
      message: archived ? 'Pass type archived' : 'Pass type restored',
      icon: 'tim-icons icon-check-2'
    })
  } catch (err) {
    swal('Error!', archived ? 'The pass type could not be archived' : 'The pass type could not be restored', 'error')
  } finally {
    getPassTypes(false)
  }
}

onMounted(() => {
  getPassTypes()
})

return { __sfc: true,proxy, companyId, companyGroupId, baseUrl, loading, passTypes, view, j, categories, drawerOpen, selectedPassType, visiblePassTypes, durationText, allowanceText, gamesText, priceText, authConfig, getPassTypes, switchTab, createPassType, editPassType, archivePrompt, setArchived, PassTypeDrawer }
}

})